<template>
  <div class="fixed top-0 right-0 flex justify-center gap-2 items-center flex-col">
    <a :href="config.socials.instagram" class="text-brand-dark p-2 hover:text-dark">
      <IconInstagram class="size-6" />
    </a>
    <a :href="config.socials.facebook" class="text-brand-dark p-2  hover:text-dark">
      <IconFacebook class="size-6" />
    </a>
    <a :href="`tel:${config.contact.phone}`" class="text-brand-dark p-2  hover:text-dark">
      <PhoneIcon class="size-6" />
    </a>
    <a :href="`mailto:${config.contact.email}`" class="text-brand-dark p-2  hover:text-dark">
      <EnvelopeIcon class="size-6" />
    </a>
  </div>
</template>
<script setup lang="ts">
import { PhoneIcon, EnvelopeIcon  } from "@heroicons/vue/24/outline";

const config = useRuntimeConfig().public;
</script>